export const nsElements = ['svg', 'use'];
